// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"60601152","500":"fa9f4e76","638":"36ba538b"}[chunkId] + ".chunk.js";
};